/* eslint-disable import/no-default-export */
import React, { ButtonHTMLAttributes } from 'react';

import classNames from 'classnames';

import styles from './primary-button.less';

type PrimaryButtonProps = React.DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

const PrimaryButton: React.FunctionComponent<PrimaryButtonProps> = ({
  className = '',
  ...props
}) => (
  <button className={classNames(styles.primaryButton, className)} {...props} />
);

export default PrimaryButton;
